import React from 'react'

const NotData = (props) => {
  return (
    <div className='w-full h-full flex justify-center items-center p-10'>
      <div className='flex justify-center items-center gap-2'>
        <p>데이터가 존재하지 않습니다</p>
        <p className='text-lg'>📑</p>
      </div>
    </div>
  )
}

export default NotData